<form (ngSubmit)="confirm()" [attr.data-qa]="qaTag + '-form'" class="form">
    <div [attr.data-qa]="qaTag" class="modal-dialog tag-autocomplete-dialog">
        <div class="tag-autocomplete-dialog-header">
            <h2 class="modal-dialog-title">{{ 'TAGS.AUTOCOMPLETE.DIALOG_TITLE' | translate }}</h2>
            <p class="tag-autocomplete-dialog-hint">{{ 'TAGS.AUTOCOMPLETE.DIALOG_HINT' | translate }}</p>
        </div>
        @let visibleRows = this.visibleRows();
        @let filterText = this.filterText();
        @let filterPlaceholder = 'TAGS.AUTOCOMPLETE.FILTER_PLACEHOLDER' | translate;
        <div class="tag-autocomplete-filter">
            <app-text-input (ngModelChange)="onFilterTextChange($event)"
                            [ariaLabel]="filterPlaceholder"
                            [ngModelOptions]="{standalone: true}"
                            [ngModel]="filterText"
                            [placeholder]="filterPlaceholder"
                            inputId="tag-autocomplete-dialog-filter-input"
                            qaTag="tag-autocomplete-dialog-filter-input">
                <app-icon [iconSize]="AppIconSizeEnum.SMALL" [svgIcon]="ICONS.FILTER" appContentPrefix aria-hidden="true" class="tag-autocomplete-filter-icon"/>
            </app-text-input>
        </div>
        <p aria-live="polite" class="visually-hidden" data-qa="tag-autocomplete-dialog-filter-match-count">
            @if (filterText) {
                {{ 'TAGS.AUTOCOMPLETE.FILTER_MATCH_COUNT' | translate:{count: visibleRows.length, total: matchTable.rows.length} }}
            }
        </p>
        @if (visibleRows.length === 0) {
            <p class="tag-autocomplete-filter-no-matches" data-qa="tag-autocomplete-dialog-filter-no-matches">
                {{ 'TAGS.AUTOCOMPLETE.FILTER_NO_MATCHES' | translate:{filterText: filterText} }}
            </p>
        } @else {
            <div class="list-with-visual-container tag-autocomplete-scroll-area">
                <table class="tag-autocomplete-table">
                    <thead>
                    <tr>
                        @for (column of matchTable.columns; track column.tagDefinitionId; let columnIndex = $index) {
                            <th [id]="getColumnHeaderId(columnIndex)" class="tag-autocomplete-header-cell" scope="col">{{ column.tagDefinitionName }}</th>
                        }
                    </tr>
                    </thead>
                    <tbody>
                        @for (displayRow of visibleRows; track displayRow.rowIndex; let isFirstRow = $first) {
                            @let rowIndex = displayRow.rowIndex;
                            @let matchLabel = 'TAGS.AUTOCOMPLETE.MATCH' | translate:{index: rowIndex + 1};
                            <tr (click)="selectRow(rowIndex)"
                                [attr.data-qa]="'tag-autocomplete-row-' + rowIndex"
                                [class.is-selected]="selectedRowIndex === rowIndex"
                                class="tag-autocomplete-row">
                                @for (displayValue of displayRow.displayValues; track $index; let isFirstValue = $first, columnIndex = $index) {
                                    <td [attr.data-qa]="'tag-autocomplete-cell-' + rowIndex + '-' + columnIndex" class="tag-autocomplete-value-cell">
                                        @if (isFirstValue) {
                                            <input (change)="selectRow(rowIndex)"
                                                   [attr.aria-label]="matchLabel"
                                                   [attr.aria-labelledby]="getMatchLabelledBy(rowIndex)"
                                                   [attr.autofocus]="isFirstRow ? '' : null"
                                                   [attr.data-qa]="'tag-autocomplete-radio-' + rowIndex"
                                                   [checked]="selectedRowIndex === rowIndex"
                                                   [id]="getMatchRadioId(rowIndex)"
                                                   class="visually-hidden tag-autocomplete-radio"
                                                   name="tag-autocomplete-match"
                                                   type="radio">
                                        }
                                        <span [id]="getMatchValueId(rowIndex, columnIndex)">{{ displayValue }}</span>
                                    </td>
                                }
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
        <div class="modal-dialog-action-text-buttons">
            @if (selectedRowIndex !== undefined) {
                <app-button [appButtonType]="AppButtonTypeEnum.TEXT_ONLY_BUTTON"
                            [buttonColor]="ButtonColorEnum.RED"
                            [buttonText]="'TAGS.AUTOCOMPLETE.APPLY_BUTTON' | translate"
                            [buttonType]="ButtonTypeEnum.SUBMIT"
                            class="modal-dialog-action-button"
                            qaTag="tag-autocomplete-dialog-apply-button"/>
            }
            <app-button (clicked)="cancel()"
                        [appButtonType]="AppButtonTypeEnum.TEXT_ONLY_BUTTON"
                        [buttonColor]="ButtonColorEnum.BLACK_WHITE"
                        [buttonText]="'BUTTON.CANCEL' | translate"
                        class="modal-dialog-action-button"
                        qaTag="tag-autocomplete-dialog-cancel-button"/>
        </div>
    </div>
</form>
